import { useState } from "react";
import { WordSelectionItem } from "../../types/game";
import styles from "./CompletionModal.module.css";

interface CompletionModalProps {
  time: number;
  missedWords: WordSelectionItem[];
  onClose: () => void;
  onPlayAgain: () => void;
  // 新增模式参数，用于判断是否显示查看错题按钮
  mode?: "allTogether" | "matching" | "sequential";
}

export const CompletionModal = ({
  time,
  missedWords,
  onClose,
  onPlayAgain,
  mode = "matching", // 默认为matching模式
}: CompletionModalProps) => {
  const [showMissedWords, setShowMissedWords] = useState(false);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  // 判断是否显示"查看错题"按钮 - 仅在全部答题模式且有错题时显示
  const shouldShowReviewButton =
    mode === "allTogether" && missedWords.length > 0;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>完成！</h2>
        <p className={styles.info}>用时: {formatTime(time)}</p>

        {missedWords.length > 0 ? (
          <div className={styles.missedWords}>
            <p className={styles.missedWordsTitle}>
              有 {missedWords.length} 个错误答案
              <button
                className={styles.toggleButton}
                onClick={() => setShowMissedWords(!showMissedWords)}
              >
                {showMissedWords ? "隐藏" : "显示"}
              </button>
            </p>

            {showMissedWords && (
              <div className={styles.wordsList}>
                {missedWords.map((word, index) => (
                  <div key={index} className={styles.wordItem}>
                    <span className={styles.wordText}>{word.word}</span>
                    <span className={styles.meaningText}>
                      {word.correctAnswer}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <p className={styles.perfectScore}>太棒了！全部正确！</p>
        )}

        <div className={styles.buttons}>
          <button className={styles.playAgainButton} onClick={onPlayAgain}>
            再玩一次
          </button>

          {/* 只在全部答题模式显示"查看错题"按钮 */}
          {shouldShowReviewButton && (
            <button className={styles.closeButton} onClick={onClose}>
              查看错题
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
